export default "__VITE_PUBLIC_ASSET__4afa5b4b__"